// Vue related imports
import Vue from 'vue';
import App from '@/app.vue';
import router from '@/router';
import store from '@/store';
import sentry from '@/plugins/sentry';

// Axios related imports
import axios from 'axios';
import VueAxios from 'vue-axios';

// Google analytics related imports
import VueGtag from 'vue-gtag';

// Auth0 related imports
import { audience, clientId, domain } from '../auth.config.json';
import { Auth0Plugin } from '@/auth';

// Chapman related imports
import UtilitiesPurchasing from '@chapmanautogroup/utilities.purchasing.vue2';

const isProduction = process.env.NODE_ENV === 'production';

/*
    Set up Axios. It is done here and this way for the auth package, which
    requires axios to be bound to the Vue instance.
*/
Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = isProduction
    ? '/api/'
    : 'http://localhost:59692/api/';

// Set up Sentry
const sentryConfig = {
    dsn: 'https://2402987534af4fdf82472ec2c7cc76b4@sentry.io/5191067',
    release: process.env.VUE_APP_SENTRY_RELEASE,
};
Vue.use(sentry, sentryConfig);

// Set up analytics
if (isProduction) {
    try {
        Vue.use(
            VueGtag,
            {
                // analytics
                config: { id: 'UA-547488-63' },
                includes: [
                    // tag manager
                    {
                        id: 'GTM-K6XXRV7',
                        params: {
                            send_page_view: false,
                        },
                    },
                ],
            },
            router
        );
        // eslint-disable-next-line
        console.log('Analytics enabled');
    } catch (err) {
        // eslint-disable-next-line
        console.log(
            `Analytics not enabled: process is ${process.env.NODE_ENV}`
        );
    }
}

// Set up Auth0
Vue.use(Auth0Plugin, {
    domain,
    clientId,
    audience,
    onRedirectCallback: appState => {
        router.push(
            appState && appState.targetUrl
                ? appState.targetUrl
                : window.location.pathname
        );
    },
});

// Install Chapman purchasing plugin
Vue.use(UtilitiesPurchasing, {
    modules: ['fees', 'financing', 'steps', 'vehicle'],
    store,
});

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
